import * as d3 from "d3";
import { addCommas, genderTooltip } from './helpers';
import $ from 'jquery';
import { stackedBarChart } from './stackedbar'
import { raceBarChart } from './bar'
import * as d3Annotation from 'd3-svg-annotation';
import * as axios from 'axios';

var margin = { top: 60, right: 180, bottom: 30, left: 50 },
  width = 960 - margin.left - margin.right,
  height = 420 - margin.top - margin.bottom;

const pageWidth = window.innerWidth

const parseDate = d3.timeParse("%Y-%m-%d");

var bisectDate = d3.bisector(function (d) {
  return d.date;
}).left;

var x = d3.scaleTime().range([0, width]);
var y = d3.scaleLinear().range([height, 0]);

var area = d3.area()
  .x(function (d) { return x(d.date); })
  .y0(height)
  .y1(function (d) { return y(d.value); });

var valueline = d3.line()
  .x(function (d) { return x(d.date); })
  .y(function (d) { return y(d.value); });

var svg = d3.select("#ptchart").append("svg")
  .attr("width", width + margin.left + margin.right)
  .attr("height", height + margin.top + margin.bottom)
  .append("g")
  .attr("transform",
    "translate(" + margin.left + "," + margin.top + ")");

function resize() {

  const caseData = axios.get("https://docs.google.com/spreadsheets/d/e/2PACX-1vRb8zyDNZXyPrSgwxUxENm2jKPV-ewDJF_CbEGWvCNuYzXZT_6YwCv209lTeyI6tUIL6jRl6ZWD5Dcv/pub?gid=1704181121&single=true&output=csv")
    .then(content => {
      const justData = content.data
      const csv = d3.csvParse(justData)

      let pop = csv

      let data = pop
      updateChart(data)

      d3.selectAll(".genderbuttonc").on("click", function () {
        var section = d3.select(this).attr("id");
        if (d3.select(this).classed("selected")) {
        } else {
          d3.selectAll(".genderbuttonc").classed("selected", false);
          d3.select(this).classed("selected", true);
        }
        if (section == 'All') { data = pop } else {
          data = pop.filter(d => d.sex == section)
        }

        updateChart(data);
      })

      updateChart(pop);

    });

  function updateChart(selectedData) {
    const data = d3.nest()
      .key(d => d.date)
      .rollup(v => d3.sum(v, d => d.value))
      .entries(selectedData);

    data.forEach((d) => {
      d.date = parseDate(d.key);
      d.value = +d.value;
    })
    data.sort((a, b) => a.date - b.date)


    x.domain(d3.extent(data, function (d) { return d.date; }));
    y.domain([0, d3.max(data, function (d) { return d.value; })]);

    var state = svg.selectAll("path")
      .data([data])

    state.enter().append('path')
      .attr("class", "area")

    state.transition()
      .attr("d", area)
      .attr('fill', '#DAD9D5')

    state.exit().remove()

    d3.select('.capacityline').remove()

    var capacityLine = svg.append("g")
      .append("line")
      .attr('class', 'capacityline')
      .attr('stroke-width', '1px')
      .attr('stroke', '#4D4E56')
      .attr('stroke-dasharray', 4)

    capacityLine.transition().duration(0)
      .attr('x1', 0)
      .attr('y1', d => y(12404))
      .attr('x2', width)
      .attr('y2', d => y(12404))

    // var edge = svg.selectAll('line')
    // .data([data])

    // edge.enter().append('path')
    // .attr("class", "line")

    // edge.transition()
    // .attr("d", valueline);

    // edge.exit().remove()

    // // add the valueline path.
    // svg.append("path")
    //     .data([data])
    //     .attr("class", "line")
    //     .attr("d", valueline);

    const csvClone = JSON.parse(JSON.stringify(selectedData));
    csvClone.forEach((d, i) => {
      d.day = parseDate(d.date);
    });
    csvClone.sort((a, b) => b.day - a.day)

    var currdate = csvClone[0].date


    const annotations = [
      {
        note: {
          label: "La capacidad del sistema carcelario, establecida por la Junta de Correccionales Estatales y Comunitarias, es de 12,404 personas.",
          wrap: 150,
          align: "left"
        },
        data: { date: currdate, population: 12404 },
        dy: 30,
        dx: 20
      },
      {
        note: {
          label: "Después de la pandemia del COVID-19, la población encarcelada disminuyó en un 30 por ciento y cayó por debajo del umbral de capacidad penitenciaria.",
          wrap: 150,
          align: "center"
        },
        data: { date: "2020-05-01", population: 10692 },
        dy: -55,
        dx: 10,
        connector: "none"
      }
    ].map(function (d) { d.color = "#4D4E56"; return d })

    d3.select('.annotation-group').remove()

    const makeAnnotations = d3Annotation.annotation()
      .type(d3Annotation.annotationLabel)
      .accessors({
        x: d => x(parseDate(d.date)),
        y: d => y(d.population)
      })
      .annotations(annotations)

    svg.append("g")
      .attr("class", "annotation-group")
      // .attr("transform", "translate(" + margin.left + "," + margin.top + ")")
      .call(makeAnnotations)

    svg.selectAll(".axis").remove();

    svg.append("g")
      .attr("transform", "translate(0," + height + ")")
      .attr('class', 'x axis')
      .call(d3.axisBottom(x).tickFormat(d3.timeFormat("%b %Y")).ticks(5));

    svg.append("g")
      .attr('class', 'y axis')
      .call(d3.axisLeft(y));

    // tooltips

    var mainTooltip = d3.select("body").append("div")
      .attr("class", "mainTooltip");

    const focus = svg.append('g').attr("class", "focus")

    focus.style("display", "none");

    focus.append("rect")
      .attr('x', -.5)
      .attr('y', 0)
      .attr('width', 1)
      .attr('height', height)
      .attr('fill', '#666')

    const overlay = svg.append('rect')

    overlay
      .attr("class", "overlay")
      .attr("width", width)
      .attr("height", height)
      .on("mouseover", function () {
        focus.style("display", null);
      })
      .on("mouseout", function () {
        focus.style("display", "none");
        mainTooltip.style("visibility", "hidden");
      })
      .on("mousemove", mousemove);

    function mousemove() {
      var main_hover = d3.select('.main-hover')
      main_hover.attr("y", event.pageY - 140 + "px").attr('x', 0)

      var x0 = x.invert(d3.mouse(this)[0]),
        i = bisectDate(data, x0, 1),
        d0 = data[i - 1],
        d1 = data[i],
        d = x0 - d0.date > d1.date - x0 ? d1 : d0;

      var formatTime = d3.timeFormat("%m/%d/%Y");

      focus.attr("transform", "translate(" + x(d.date) + "," + 0 + ")");

      const tooltip_str = formatTime(d.date) + '<br/>' + addCommas(d.value)

      mainTooltip
        // .style('left', (pageWidth - width) + x(d.date) + 'px')
        .style('left', (pageWidth - (width + margin.right + margin.left)) / 2 + (margin.left / 2) + 5 + x(d.date) + 'px')
        .style("top", event.pageY - 140 + "px").attr('x', 0)
        .html(tooltip_str)
        .style("visibility", "visible")



    }

    //end tooltips

  }

}
$(document).ready(function () {
  $('#All.genderbuttona.selected').trigger('click');
})

d3.select(window).on("resize", resize);

resize()


stackedBarChart()
raceBarChart()

genderTooltip()